<div class="floor-wrapper" *ngIf="floorData?.floorId && !floorData.hideFloor; else otherContent">
  <div class="floor-data" [ngClass]="{ 'opacity-on': !floorData.isHighlighted }">
    <div class="floor-data__floornum" [ngClass]="{ 'invalid-data': !isFloorIndexValid }">
      {{ floorLabel || ('commonLabels.na' | xTranslate) }}
    </div>
    <div class="floor-data__area" [ngClass]="{ 'invalid-data': isFloorAreaExceeded }">
      {{ floorAreaLabel || ('commonLabels.na' | xTranslate) }}
    </div>
    <div class="floor-data__floor-plan">
      <a *ngIf="floorData.floorImageURL" (click)="downloadFloorPlan(floorData.floorImageURL)">
        <mat-icon
          svgIcon="floor-plan"
          [matTooltip]="'commonLabels.downloadFloorPlan' | xTranslate"
          matTooltipClass="tooltip-custom"
          matTooltipPosition="above"
          aria-hidden="false"
        ></mat-icon
      ></a>
    </div>
  </div>
  <div class="item-data">
    <ng-container *ngIf="floorData.isHighlighted; else noPropertyTypeDataFound">
      <ng-container *ngFor="let item of items | sort: { by: 'isHighlighted', order: -1 }">
        <sp-item
          *ngIf="item.isHighlighted; else noPropertyTypeDataFound"
          class="item-data-wrapper"
          [item]="item"
          [selectedUsageType]="selectedUsageType"
          [totalNumberOfFloors]="totalNumberOfFloors"
          [floorData]="floorData"
          [containerRecordFloors]="containerRecordFloors"
        ></sp-item>
      </ng-container>
    </ng-container>

    <ng-template #noPropertyTypeDataFound>
      <div
        class="filler item-data-wrapper"
        [matTooltip]="'commonLabels.nonXXXArea' | xTranslate: { value: selectedUsageType }"
        matTooltipClass="tooltip-custom"
        matTooltipPosition="above"
      ></div>
    </ng-template>

    <!-- TODO SP: review if floorData.floorIndex.toString() above is right to be used -->
    <!-- This filler is to fill remainder of the horizontal width, this also need to be conditional(true) when floor is not full -->
    <div
      *ngIf="showInformationNotAvailable && floorData.isHighlighted"
      [ngClass]="{
        filler: selectedUsageType != null,
        'no-data__found no-data__full-width': selectedUsageType == null,
      }"
      [matTooltip]="'commonLabels.informationNotAvailable' | xTranslate"
      matTooltipClass="tooltip-custom"
      matTooltipPosition="above"
    ></div>
  </div>
</div>
<ng-template #otherContent>
  <div class="no-data" *ngIf="!floorData?.hideFloor">
    <div class="floor-data" [ngClass]="{ 'opacity-on': !highlightVirtualFloor }">
      <div class="floor-data__floornum">
        <!-- TODO: Review what is the best placeholder to use -->
        {{ floorLabel || ('commonLabels.na' | xTranslate) }}
      </div>
      <div class="floor-data__area" [ngClass]="{ 'invalid-data': isFloorAreaExceeded }">
        {{ floorAreaLabel || ('commonLabels.na' | xTranslate) }}
      </div>
    </div>
    <div
      class="no-data__found"
      [matTooltip]="'commonLabels.informationNotAvailable' | xTranslate"
      matTooltipClass="tooltip-custom"
      matTooltipPosition="above"
      [ngClass]="{ 'no-data__found--filler': !highlightVirtualFloor }"
    ></div>
  </div>
</ng-template>
